import { api } from '@api/api2';
import type { GetRizersPayload } from './types';

export const getRizers = (payload: GetRizersPayload) =>
  api.no_vers('get', 'admin/get-rizer', { ...payload, per_page: 1000 });
